var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.budget
    ? _c("div", { staticClass: "px-15" }, [
        _c("div", { staticClass: "btn-group" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary btn-round dropdown-toggle",
              staticStyle: { "text-transform": "uppercase" },
              attrs: {
                type: "button",
                "data-toggle": "dropdown",
                "aria-expanded": "false",
              },
            },
            [_vm._v(" " + _vm._s(_vm.budget.status) + " ")]
          ),
          _c("div", { staticClass: "dropdown-menu", attrs: { role: "menu" } }, [
            _vm.budget.status == "draft"
              ? _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    attrs: { href: "javascript:void(0)", role: "menuitem" },
                    on: {
                      click: function ($event) {
                        return _vm.update("scheduled")
                      },
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "icon md-long-arrow-up",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v("Publish "),
                  ]
                )
              : _vm._e(),
            _vm.budget.status == "draft"
              ? _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    attrs: { href: "javascript:void(0)", role: "menuitem" },
                    on: {
                      click: function ($event) {
                        return _vm.update("archived")
                      },
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "icon md-archive",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v("Archive "),
                  ]
                )
              : _vm._e(),
            _vm.budget.status == "scheduled"
              ? _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    attrs: { href: "javascript:void(0)", role: "menuitem" },
                    on: {
                      click: function ($event) {
                        return _vm.update("draft")
                      },
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "icon md-long-arrow-down",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v(" Unpublish "),
                  ]
                )
              : _vm._e(),
            _vm.budget.status == "ongoing"
              ? _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    attrs: { href: "javascript:void(0)", role: "menuitem" },
                    on: { click: _vm.confirmAborted },
                  },
                  [
                    _c("i", {
                      staticClass: "icon mdi mdi-cancel",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v("Abort "),
                  ]
                )
              : _vm._e(),
            _vm.budget.status == "ongoing"
              ? _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    attrs: { href: "javascript:void(0)", role: "menuitem" },
                    on: {
                      click: function ($event) {
                        return _vm.update("paused")
                      },
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "icon mdi mdi-pause",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v("Pause "),
                  ]
                )
              : _vm._e(),
            _vm.budget.status == "paused"
              ? _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    attrs: { href: "javascript:void(0)", role: "menuitem" },
                    on: {
                      click: function ($event) {
                        return _vm.update("ongoing")
                      },
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "icon md-long-arrow-up",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v("Publish "),
                  ]
                )
              : _vm._e(),
            _vm.budget.status == "archived"
              ? _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    attrs: { href: "javascript:void(0)", role: "menuitem" },
                    on: {
                      click: function ($event) {
                        return _vm.update("draft")
                      },
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "icon md-long-arrow-up",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v("Unarchive "),
                  ]
                )
              : _vm._e(),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }